import {useListView} from '../../core/ListViewProvider'
import {CountriesListToolbar} from './CountryListToolbar'
import {CountriesListGrouping} from './CountriesListGrouping'
import {CountriesListSearchComponent} from './CountriesListSearchComponent'

const CountriesListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <CountriesListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <CountriesListGrouping /> : <CountriesListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {CountriesListHeader}
